export const stripeConfig =
  import.meta.env.VITE_TARGET_ENV === 'production'
    ? {
        publishableKey: 'pk_live_9Ul2YoB6aq1UPgyMTox0DkPm',
        pricingTableId: 'prctbl_1Scik3D5Mn8ytyEDq1qh5JQB',
      }
    : {
        publishableKey:
          'pk_test_51RBf8yRloOzc9iwlLQE5AO2F1Z45ejI2THEmcjg8RE6TEpkZ5oY7PV7XC91db2A6urbBZl4biC7bV3iLG4viJQb500Y7cMZObQ',
        pricingTableId: 'prctbl_1REYj3RloOzc9iwlU9l90qtv',
      };
